import React, { Fragment, FC, ReactNode } from 'react';
import LinkifyIt from 'linkify-it';
import tlds from 'tlds';
import _ from 'lodash';
import Linkify from 'react-linkify';
import { useRemoAdminCtx } from 'react-scale/components/remoAdmin/remoAdminContext';

const QAAAS_LINKS = ['QAaaSTaskViewLink', 'QAaaSTaskDisputeLink'];

const TABLE_EXCLUDE_KEYS = [
  'preserveCfUrls',
  'SampleTask',
  'ProjectMetricsEnabled',
  'DeliveryPortal',
  'QuickLinters',
];

const formatWords = (str: string) => _.words(str).join(' ');

interface DetailsTableProps extends Record<string, ReactNode | ReactNode[]> {}

const RenderDetail: FC<{ detail: any }> = ({ detail }: { detail: any }) => {
  if (Array.isArray(detail)) {
    return detail.map((part, i) => <Fragment key={i}>{part}</Fragment>);
  }
  return detail;
};

export default function DetailsTable(props: DetailsTableProps) {
  const { isRemoAdmin } = useRemoAdminCtx();
  let qaaasSection;
  if ((props.QAaaSForTask || props.QAaaSForSubtask) && props.Status === 'completed') {
    qaaasSection = _.keys(props)
      .filter(key => _.isString(props[key]) && QAAAS_LINKS.includes(key))
      .map((key, i) => (
        <div key={i} className="row">
          <span className="key">{formatWords(key)}</span>&nbsp;
          <span className="val">
            <a href={props[key] as string}>link</a>
          </span>
        </div>
      ));
  } else {
    qaaasSection = <div></div>;
  }

  return (
    <Linkify matchDecorator={httpLinkMatcher}>
      <div>
        {_.keys(props)
          .filter(
            key =>
              !_.isNil(props[key]) &&
              !TABLE_EXCLUDE_KEYS.includes(key) &&
              !QAAAS_LINKS.includes(key),
          )
          .map((key, i) => (
            <div key={i} className="row">
              <span className="key">{formatWords(key)}</span>&nbsp;
              <span className="val">
                <RenderDetail detail={props[key]} />
              </span>
            </div>
          ))}

        {qaaasSection}

        <div className="row">
          <span className="key">{props.SampleTask}</span>
        </div>
        {/* THESE SECTIONS DO NOT WORK IN REMOADMIN DUE TO THEM USING REACT ROUTER-SPECIFIC COMPONENTS, NOT COMPATIBLE WITH NEXTJS */}
        {!isRemoAdmin && (
          <>
            <div className="row">
              <span className="key">{props.ProjectMetricsEnabled}</span>
            </div>
            <div className="row">
              <span className="key">{props.DeliveryPortal}</span>
            </div>
            {props.QuickLinters && <div className="row">{props.QuickLinters}</div>}
          </>
        )}
        <style jsx>{`
          .row {
            margin: 8px 0;
            font-weight: bold;
          }

          .key {
            display: inline-block;
            padding-right: 4px;
          }

          .val {
            font-weight: normal;
          }
        `}</style>
      </div>
    </Linkify>
  );
}

const linkify = new LinkifyIt().tlds(tlds).set({ fuzzyEmail: false });

const httpLinkMatcher = (text: string) => {
  return linkify.match(text);
};
